module.exports = __webpack_public_path__ + "img/battle_section1_item3.26aabb9f.png";